import {baseLocalConfig} from './local.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const baseDevConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseLocalConfig, {
  environmentName: "Prism Development Environment",
  hubApi: "https://hubstd-piggy.cbsi.com",
  ionicEnvName: 'dev',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/base/dev.config.ts